import { GridItem } from '@chakra-ui/react';

const ComponentMiniature = ({ name, img64, innerRef, providedDrag, isDragging, miniatureStyle }) => {
	return (
		<GridItem
			transform={isDragging ? '' : 'none !important'}
			ref={innerRef}
			{...providedDrag.draggableProps}
			{...providedDrag.dragHandleProps}
			transition={!isDragging ? '0s !important' : false}
			{...miniatureStyle}
		>
			<figure style={{ margin: 0, height: '100px', display: 'flex', flexDirection: 'column' }}>
				<img alt={name} src={img64} style={{ maxHeight: '68px', margin: 'auto' }} />
				<figcaption>{name}</figcaption>
			</figure>
		</GridItem>
	);
};

export default ComponentMiniature;
